import styled, { css } from "styled-components";
import { Wrapper } from 'AppReact';

const template = styled.div`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 86px;
    padding-left: 30px;
    padding-right: 20px;

    span {
      display: none;
    }

    &:hover {
      background-color:  ${`${theme?.colour?.primary}0D`};
      span {
        display: unset;
      }
    }
  `}
`;

export default Wrapper(template);